<template>
  <div class="mt-6">
    <p class="has-text-weight-bold">
      {{ $t("mp:page.application_details.uploaded_documents.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("mp:page.application_details.uploaded_documents.subtitle") }}
    </p>

    <template v-if="loaded">
      <template v-if="documents && documents.length > 0">
        <div v-for="(doc, i) in documents" :key="i">
          <div class="columns setting-tile mx-0 my-2">
            <b-icon
              icon-pack="far"
              icon="vote-yea"
              type="is-blue"
              size="is-medium"
              class="mr-2"
            ></b-icon>

            <span class="has-text-blue setting-tile-filename">
              {{ doc.fileName }}
            </span>

            <div class="ml-auto">
              <span class="cursor-pointer" @click="downloadFile(doc)">
                <b-icon
                  icon-pack="fa"
                  icon="download"
                  type="is-blue"
                  class="mr-2"
                ></b-icon>
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="columns setting-tile mx-0 my-2">
          <div class="column">
            {{ $t("mp:page.application_details.uploaded_documents.empty") }}
          </div>
        </div>
      </template>
    </template>

    <LoadingSkeleton v-else />
  </div>
</template>

<script>
import LoadingSkeleton from "../LoadingSkeleton";
import documentMixin from "../../mixins/documentMixin";

export default {
  name: "ApplicationDetailsUploadedDocuments",
  components: { LoadingSkeleton },
  mixins: [documentMixin],
  props: {
    applicationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      loaded: false,
    };
  },
  async created() {
    await this.$store.dispatch(
      "applicationAdmin/fetchUploadedDocuments",
      this.applicationId
    );
    this.documents = this.$store.getters[
      "applicationAdmin/geUploadedDocuments"
    ](this.applicationId);
    this.loaded = true;
  },
};
</script>

<style scoped lang="scss">
.setting-tile-filename {
  padding-top: 0.5rem;
  padding-left: 0.5rem;
}
</style>
